import { render, staticRenderFns } from "./CompanyLeadMigration.vue?vue&type=template&id=2661d800&scoped=true"
import script from "./CompanyLeadMigration.vue?vue&type=script&lang=js"
export * from "./CompanyLeadMigration.vue?vue&type=script&lang=js"
import style0 from "./CompanyLeadMigration.vue?vue&type=style&index=0&id=2661d800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661d800",
  null
  
)

export default component.exports